// extracted by mini-css-extract-plugin
export default {"home":"Home_home__N62Ro","content":"Home_content__R2Ets"};